import Routes from 'views/components/common/Routes/Routes';

export default Routes;
